
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesTaxGrid extends Serenity.EntityGrid<POSSalesTaxRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesTax'; }
        protected getIdProperty() { return POSSalesTaxRow.idProperty; }
        protected getInsertPermission() { return POSSalesTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesTaxRow.localTextPrefix; }
        protected getService() { return POSSalesTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}